import { type ReactNode } from 'react';

/** A centred block with the otter image, a sentence, and an optional action button. */
export function EmptyState({ image, title, children }: { image?: string; title: string; children?: ReactNode }) {
  return (
    <div className="empty-state">
      <img src="/apple-touch-icon.png" alt="" className="empty-state-img" aria-hidden="true" width="72" height="72" />
      <p>{title}</p>
      {children ? <div className="empty-state-actions">{children}</div> : null}
    </div>
  );
}
